export const SupportedTokens = [
  {
    id: 0,
    name: "APIX",
    ticker: "APIX",
    contractAddr: "0xf51EBf9a26DbC02B13F8B3a9110dac47a4d62D78",//"0x0924B39fcd40cC4F9E6F7c3AF53f190b123c3C7e",
    isOpened: true,
  },
  {
    id: 1,
    name: "Wrapped Ether",
    ticker: "WETH",
    contractAddr: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
    isOpened: true,
  },
  {
    id: 2,
    name: "Wrapped DASH",
    ticker: "wDASH",
    contractAddr: "0x29c8c00ec4d2Aac7232D4B974707b850c1c28285", //"0x52C10C5eb72eA100ef30fD5896E1D4DD9d8C85D6",
    isOpened: true,
  },
  /*
  {
    id: 2,
    name: "Wrapped Zcoin",
    ticker: "wXZC",
    contractAddr: "0x5eb191d30665EAB255b25Ce797052878dDD3BB6F",
    isOpened: true,
  }
  */
]
//0x30e74d810b0b12e2ede957dcdbc85fe1b87b59d9

export const SwapContracts = [ //taker's view - (creator & contract is inverted)
  { //APIX to WETH
    id: 0,
    fromToken: 0,
    toToken: 1,
    contractAddr: "0x7C920052128a8CCF31270059F23bbEFCceE93E11",
    isOpened: true,
  },
  { //APIX to wDASH
    id: 1,
    fromToken: 0,
    toToken: 2,
    contractAddr: "0x0000000000000000000000000000000000000001",
    isOpened: true,
  },
  { //WETH to APIX
    id: 2,
    fromToken: 1,
    toToken: 0,
    contractAddr: "0x6764ceE77800a1276EA3eaC5Cb97ce6b86A40fFA",
    isOpened: true,
  },
  { //WETH to wDASH
    id: 3,
    fromToken: 1,
    toToken: 2,
    contractAddr: "0xEb58Bf93AB6427F58D2d4672ffED744E2F869B69",
    isOpened: true,
  },
  { //wDASH to APIX
    id: 4,
    fromToken: 2,
    toToken: 0,
    contractAddr: "0x0000000000000000000000000000000000000002",
    isOpened: true,
  },
  { //wDASH to WETH
    id: 5,
    fromToken: 2,
    toToken: 1,
    contractAddr: "0x0000000000000000000000000000000000000003",
    isOpened: true,
  },
]

/*
export const SwapContracts = [ //taker's view - (creator & contract is inverted)
  { //APIX to wDASH
    id: 0,
    fromToken: 0,
    toToken: 1,
    contractAddr: "0x949F93e213ae40d359cAbd6F2f31EC07FBe1DF38",
    isOpened: true,
  },
  { //APIX to wXZC
    id: 1,
    fromToken: 0,
    toToken: 2,
    contractAddr: "0xde4f085715f7aB624e9cB71C050F29a3dE2392DE",
    isOpened: true,
  },
  { //wDASH to APIX
    id: 2,
    fromToken: 1,
    toToken: 0,
    contractAddr: "0x06a029103c7ef8318a447625820bf9baa7c4ce93",
    isOpened: true,
  },
  { //wDASH to wXZC
    id: 3,
    fromToken: 1,
    toToken: 2,
    contractAddr: "0xCc4aDdF38AF16e4606bE3F3901d5D7408B3a7Cf5",
    isOpened: true,
  },
  { //wXZC to APIX
    id: 4,
    fromToken: 2,
    toToken: 0,
    contractAddr: "0x53487cEF4d7b4b9995Ee649D092a5AfaD9caD4a6",
    isOpened: true,
  },
  { //wXZC to wDASH
    id: 5,
    fromToken: 2,
    toToken: 1,
    contractAddr: "0x8eCd240aBC41C786290ae43D4270eff89A5C49fc",
    isOpened: true,
  },
]
*/

export const SwapContractsTestnet = [ //taker's view - (creator & contract is inverted)
  { //APIX to wDASH
    id: 0,
    fromToken: 0,
    toToken: 1,
    contractAddr: "0xdfD5F5Ea9700C9B1dB5B0545dc2bD286fa04A2E4",
    isOpened: true,
  },
  { //APIX to wXZC
    id: 1,
    fromToken: 0,
    toToken: 2,
    contractAddr: "0xE89C73f41159A86Cf21E29b7632b1b7DC425bc07",
    isOpened: true,
  },
  { //wDASH to APIX
    id: 2,
    fromToken: 1,
    toToken: 0,
    contractAddr: "0xc145E8d079b92AA13C713F0C954232eaA8D40962",
    isOpened: true,
  },
  { //wDASH to wXZC
    id: 3,
    fromToken: 1,
    toToken: 2,
    contractAddr: "0x91286021141c833D3a598422fA549cb0BCF013bd",
    isOpened: true,
  },
  { //wXZC to APIX
    id: 4,
    fromToken: 2,
    toToken: 0,
    contractAddr: "0x1d820D61903493e5720Af6d1660FDBf710Cb2247",
    isOpened: true,
  },
  { //wXZC to wDASH
    id: 5,
    fromToken: 2,
    toToken: 1,
    contractAddr: "0x49042790Af41f92107a249Ea9523c8cC262Dab55",
    isOpened: true,
  },
]


export const SwapContractABI = [
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "uint256",
				"name": "_swapOrderID",
				"type": "uint256"
			}
		],
		"name": "cancelSwapOrder",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "address",
				"name": "nextOperator",
				"type": "address"
			}
		],
		"name": "changeOperator",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "uint256",
				"name": "SwapID",
				"type": "uint256"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "from",
				"type": "address"
			}
		],
		"name": "CancelSwapOrder",
		"type": "event"
	},
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "uint256",
				"name": "_fromTokenAmount",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "_toTokenAmount",
				"type": "uint256"
			}
		],
		"name": "createSwapOrder",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "uint256",
				"name": "SwapID",
				"type": "uint256"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "from",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "fromTokenAmount",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "toTokenAmount",
				"type": "uint256"
			}
		],
		"name": "CreateSwapOrder",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "uint256",
				"name": "SwapID",
				"type": "uint256"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "from",
				"type": "address"
			}
		],
		"name": "FinishSwapOrder",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "uint256",
				"name": "SwapID",
				"type": "uint256"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "from",
				"type": "address"
			}
		],
		"name": "ForceFinishSwapOrder",
		"type": "event"
	},
	{
		"constant": false,
		"inputs": [],
		"name": "freezeSwap",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"anonymous": false,
		"inputs": [],
		"name": "FreezeSwap",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "address",
				"name": "oldOperator",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "address",
				"name": "newOperator",
				"type": "address"
			}
		],
		"name": "OperatorChange",
		"type": "event"
	},
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "uint256",
				"name": "_swapOrderID",
				"type": "uint256"
			}
		],
		"name": "takeSwapOrder",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "uint256",
				"name": "SwapID",
				"type": "uint256"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "from",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "fromTokenAmount",
				"type": "uint256"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "toTokenAmount",
				"type": "uint256"
			}
		],
		"name": "TakeSwapOrder",
		"type": "event"
	},
	{
		"constant": false,
		"inputs": [],
		"name": "unfreezeSwap",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"anonymous": false,
		"inputs": [],
		"name": "UnfreezeSwap",
		"type": "event"
	},
	{
		"constant": true,
		"inputs": [],
		"name": "fromTokenAddress",
		"outputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"payable": false,
		"stateMutability": "view",
		"type": "function"
	},
	{
		"constant": true,
		"inputs": [
			{
				"internalType": "uint256",
				"name": "_swapOrderID",
				"type": "uint256"
			}
		],
		"name": "isSwapOrderExecutable",
		"outputs": [
			{
				"internalType": "bool",
				"name": "isSwappable",
				"type": "bool"
			}
		],
		"payable": false,
		"stateMutability": "view",
		"type": "function"
	},
	{
		"constant": true,
		"inputs": [],
		"name": "Operator",
		"outputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"payable": false,
		"stateMutability": "view",
		"type": "function"
	},
	{
		"constant": true,
		"inputs": [],
		"name": "swapCount",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"payable": false,
		"stateMutability": "view",
		"type": "function"
	},
	{
		"constant": true,
		"inputs": [],
		"name": "swapFrozen",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"payable": false,
		"stateMutability": "view",
		"type": "function"
	},
	{
		"constant": true,
		"inputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"name": "SwapOrders",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "swapOrderID",
				"type": "uint256"
			},
			{
				"internalType": "address",
				"name": "swapCreator",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "swapTaker",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "fromTokenAmount",
				"type": "uint256"
			},
			{
				"internalType": "uint256",
				"name": "toTokenAmount",
				"type": "uint256"
			},
			{
				"internalType": "bool",
				"name": "isSwapOpened",
				"type": "bool"
			},
			{
				"internalType": "bool",
				"name": "isSwapCancelled",
				"type": "bool"
			},
			{
				"internalType": "bool",
				"name": "isSwapFinished",
				"type": "bool"
			}
		],
		"payable": false,
		"stateMutability": "view",
		"type": "function"
	},
	{
		"constant": true,
		"inputs": [],
		"name": "toTokenAddress",
		"outputs": [
			{
				"internalType": "address",
				"name": "",
				"type": "address"
			}
		],
		"payable": false,
		"stateMutability": "view",
		"type": "function"
	}
]


export const TokenContractABI = [
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "owner",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "spender",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "value",
				"type": "uint256"
			}
		],
		"name": "Approval",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "from",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "address",
				"name": "to",
				"type": "address"
			},
			{
				"indexed": false,
				"internalType": "uint256",
				"name": "value",
				"type": "uint256"
			}
		],
		"name": "Transfer",
		"type": "event"
	},
	{
		"constant": true,
		"inputs": [
			{
				"internalType": "address",
				"name": "owner",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "spender",
				"type": "address"
			}
		],
		"name": "allowance",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"payable": false,
		"stateMutability": "view",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "address",
				"name": "spender",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "value",
				"type": "uint256"
			}
		],
		"name": "approve",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": true,
		"inputs": [
			{
				"internalType": "address",
				"name": "who",
				"type": "address"
			}
		],
		"name": "balanceOf",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"payable": false,
		"stateMutability": "view",
		"type": "function"
	},
	{
		"constant": true,
		"inputs": [],
		"name": "totalSupply",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"payable": false,
		"stateMutability": "view",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "address",
				"name": "to",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "value",
				"type": "uint256"
			}
		],
		"name": "transfer",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "address",
				"name": "from",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "to",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "value",
				"type": "uint256"
			}
		],
		"name": "transferFrom",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	}
] 